import { useCallback } from 'react'
import { useTheme } from '@mui/material'
import { ThemeColor } from '@/theme/usePixydocsTheme'
import useThemeMode from './useThemeMode'

export default function useGetThemeColor(): (colorName?: ThemeColor) => string {
  const theme = useTheme()
  const [themeMode] = useThemeMode()

  return useCallback(
    (colorName?: ThemeColor) => {
      const themeColor = theme.palette[colorName || '']
      if (!themeColor) return theme.palette.text.secondary
      return themeColor[themeMode === 'dark' ? 'dark' : 'light']
    },
    [theme, themeMode],
  )
}
